import { useEffect, useState } from 'react'
import { Carousel } from 'react-bootstrap'
import defaultSlider from 'assets/images/demo-slider.svg'
import { useQuery } from 'react-query'
import { getAllGameQuery, getPageInfoQuery } from 'dataLayer/game'
import { useNavigate } from 'react-router-dom'

function HomeSlider() {
	const [index, setIndex] = useState(0)
	const { data: games } = useQuery(getPageInfoQuery())
	const [listSlide, setListSlide] = useState([])
	const navigate = useNavigate()

	const handleSelect = (selectedIndex, e) => {
		setIndex(selectedIndex)
	}
	useEffect(() => {
		if (games && games.length > 0) {
			const newList = games.filter(it => it.device === 1)
			setListSlide(newList)
		}
	}, [games])
	const handleClickSlider = dataSelect => {
		let type = dataSelect?.type?.toLowerCase()
		switch (type) {
			case 'href':
				navigate(dataSelect.link || '/')
				break

			default:
				break
		}
	}
	return (
		// TODO: style dot like design
		<Carousel
			className="web-slider"
			activeIndex={index}
			onSelect={handleSelect}
			controls={false}
		>
			{listSlide?.map((item, index) => (
				<Carousel.Item key={index}>
					<div onClick={() => handleClickSlider(item)}>
						<img
							src={item.image ?? defaultSlider}
							alt={item.description}
							onError={e => {
								e.target.onerror = null
								e.target.src = defaultSlider
							}}
						/>
					</div>
				</Carousel.Item>
			))}
		</Carousel>
	)
}

export default HomeSlider
